import { z } from 'zod';
import { forgotPasswordFormSchemaMessages } from './messages';

// Validação antiga: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{10,}$/
const validPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-!$%^&*()_+|~=`{}\[\]:";'<>@?,.\/]).{10,}$/;

export const forgotPasswordFormSchema = z.object({
  email: z.string().min(1, forgotPasswordFormSchemaMessages.required),
});

export const forgotPasswordConfirmSendFormSchema = z
  .object({
    newPassword: z
      .string()
      .min(1, forgotPasswordFormSchemaMessages.required)
      .min(8, forgotPasswordFormSchemaMessages.minPasswordSize)
      .regex(validPasswordRegex, forgotPasswordFormSchemaMessages.requiredPasswordCharacters),
    passwordConfirmation: z.string().min(1, forgotPasswordFormSchemaMessages.required),
  })
  .superRefine((values, ctx) => {
    if (values.newPassword !== values.passwordConfirmation) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['passwordConfirmation'],
        message: forgotPasswordFormSchemaMessages.invalidPasswordConfirmation,
      });
    }
  });

export const forgotPasswordConfirmCodeFormSchema = z.object({
  code: z.string().min(1, forgotPasswordFormSchemaMessages.required),
});
